import { render, staticRenderFns } from "./PostSorter.vue?vue&type=template&id=6e785f34&"
import script from "./PostSorter.vue?vue&type=script&lang=js&"
export * from "./PostSorter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PostSorter.vue"
export default component.exports